export default "__VITE_ASSET__pcGIoXIa__"